import { type ComputedRef } from 'vue'

import { useApprovalEligibility, type WorkspaceRank } from '@/features/platform-actions'

// The ladder lives in platform-actions (`service/approvalEligibility`): approvals and insight
// actions gate on the same rungs, and two copies would disagree the first time one is added.
export { WORKSPACE_RANK } from '@/features/platform-actions'
export type { WorkspaceRank } from '@/features/platform-actions'

export interface UseInsightActionRank {
  rank: ComputedRef<number>
  atLeast: (threshold: WorkspaceRank) => boolean
}

export function useInsightActionRank(): UseInsightActionRank {
  const { rank, atLeast } = useApprovalEligibility()
  return { rank, atLeast }
}
